import { useSpeechRecognition } from 'site/sdk/speechRecognition.tsx'
import { IS_BROWSER } from '$fresh/runtime.ts'
import { effect, signal } from '@preact/signals'
import { useAutocomplete } from 'site/sdk/useAutocomplete.ts'
import { sendEvent } from '$store/sdk/analytics.ts'

export const searchValue = signal('')
export const hasFocus = signal(false)

interface Props {
    searchId: string
    formId: string
    inputId: string
    closeId: string
    algolia?: boolean
}

export default function SearchBarJS({ searchId, formId, inputId, closeId, algolia }: Props) {
    if (!IS_BROWSER) return null
    const { setSearch } = useAutocomplete()

    const speech = useSpeechRecognition({
        onSpeech: () => {
            const m = document.querySelectorAll('.microphone') as NodeListOf<HTMLInputElement>

            for (const i of m) {
                i.value = speech.detectedText.value
                searchValue.value = speech.detectedText.value
                setSearch(speech.detectedText.value, 4, algolia)
            }
        },
        onError: (e) => {
            speech.isListening.value = false
        },
    })

    const events = () => {
        const $search = document.getElementById(searchId) as HTMLInputElement
        const $input = document.getElementById(inputId) as HTMLInputElement
        const $form = document.getElementById(formId) as HTMLInputElement
        const $close = document.getElementById(closeId) as HTMLInputElement

        $input.addEventListener('click', () => {
            !$search?.classList.contains('group') &&
                $search?.classList.add('group')
        })

        $input.addEventListener('input', (e: any) => {
            const value = e.currentTarget.value
            setSearch(value, 4, algolia)
            searchValue.value = value
        })

        $search.addEventListener('focus', () => {
            hasFocus.value = true
        })
        $search.addEventListener('blur', () => {
            if ($input) {
                hasFocus.value = false
                setSearch('')
                $input.value = ''
            }
        })

        $form.addEventListener('submit', (e) => {
            const value = $input?.value
            if (value) {
                sendEvent({
                    name: 'search',
                    params: { search_term: value },
                })
            }
        })

        $close.addEventListener('click', () => {
            $search?.classList.contains('group') &&
                $search?.classList.remove('group')
            hasFocus.value = false
            $input.value = ''
        })
    }

    const keydown = (e: KeyboardEvent) => {
        const $search = document.getElementById(searchId) as HTMLInputElement
        const $input = document.getElementById(inputId) as HTMLInputElement

        if (!$input || !$search) return

        const isEsc = e.key === 'Escape'
        const isK = e.key === 'k' || e.key === 'K' || e.keyCode === 75
        // Open Searchbar on meta+k
        if (e.metaKey === true && isK) {
            !$search?.classList.contains('group') && $search?.classList.add('group')
        } else if (isEsc) {
            $search?.classList.contains('group') && $search?.classList.remove('group')
            hasFocus.value = false
            setSearch('')
            $input.value = ''
        }
    }
    addEventListener('keydown', keydown)
    events()

    effect(() => {
        for (const i of document.querySelectorAll('.microphone-icon')) {
            i.addEventListener('click', speech.start)

            if (speech.isListening.value) {
                i.classList.add('microphone-icon-active')
            } else {
                i.classList.remove('microphone-icon-active')
            }

            if (!speech.supported) {
                i.classList.add('pointer-events-none')
                i.classList.add('opaticy-0')
            } else {
                i.classList.remove('pointer-events-none')
                i.classList.remove('opaticy-0')
            }
        }
    })

    return null
}
